import React, { useRef } from 'react';
import { useIsVisible } from 'react-is-visible';
import { useHistory } from 'react-router-dom';
import { useCountry } from '../../../contexts/CountryContext';
import useDesignUtils from '../../../hooks/useDesignUtils';
import { Box, Copy, NewPrimaryButton, VStack } from '../../SimpleUI';
import SectionLayout from '../SectionLayout';
import PropTypes from 'prop-types';
import { ResumeNumber } from './ResumeNumber';

const Separator = ({ isAr }) => (
  <Box width="2px" backgroundColor={isAr ? 'darkGreen' : 'primary'}></Box>
);

Separator.propTypes = {
  isAr: PropTypes.bool,
};

const Resume = () => {
  const nodeRef = useRef();
  const isVisible = useIsVisible(nodeRef);
  const { isMobile } = useDesignUtils();
  const { countryPrefix } = useCountry();
  const history = useHistory();
  const isAr = countryPrefix === '/ar';

  return (
    <SectionLayout
      paddingY={isAr ? 'large' : 'xxxxxlarge'}
      backgroundColor={isAr ? 'primary' : 'white'}
      justifyContent="center"
    >
      <Box
        width="100%"
        maxWidth="1200px"
        margin="auto"
        {...(!isAr && {
          borderColor: 'primary',
          borderWidth: '2px',
          borderStyle: 'solid',
          borderRadius: 'medium',
          marginX: 'xxlarge',
        })}
      >
        <VStack
          space="xxlarge"
          marginY={{ mobile: 'medium', desktop: 'xxlarge' }}
        >
          <Box display="flex" flexWrap="wrap" useRef={nodeRef}>
            <Box
              display="flex"
              width={{ mobile: '100%', desktop: '48%' }}
              justifyContent="space-evenly"
              marginBottom={{ mobile: 'xxlarge', desktop: '0' }}
            >
              <ResumeNumber
                prefix="+"
                digits={80}
                suffix="K"
                isVisible={isVisible}
              >
                personas
                <br />
                confían
              </ResumeNumber>
              <Separator isAr={isAr} />
              <ResumeNumber prefix="+" digits={27} isVisible={isVisible}>
                de proyectos
                <br />
                finalizados
              </ResumeNumber>
            </Box>
            {!isMobile && <Separator isAr={isAr} />}
            <Box
              display="flex"
              width={{ mobile: '100%', desktop: '50%' }}
              justifyContent="space-evenly"
            >
              <ResumeNumber digits={200} suffix="M" isVisible={isVisible}>
                de dólares invertidos
                <br />
                en nuestra plataforma
              </ResumeNumber>
              <Separator isAr={isAr} />
              <ResumeNumber prefix="+" digits={4} isVisible={isVisible}>
                años en
                <br />
                el mercado
              </ResumeNumber>
            </Box>
          </Box>
          <Copy
            textAlign="center"
            fontWeight="bold"
            color="_darkGray"
            fontSize="_landingResume"
            paddingX={{ mobile: 'medium', desktop: 'none' }}
          >
            La empresa líder de micro inversiones <br /> en propiedades de LATAM
          </Copy>
          <Box
            width="100%"
            maxWidth={{ mobile: '90%', desktop: '200px' }}
            margin="auto"
          >
            <NewPrimaryButton
              type="button"
              variant={isAr ? 'white' : 'green'}
              size="full"
              onClick={() => history.push(`${countryPrefix}/productos`)}
            >
              Conocé más
            </NewPrimaryButton>
          </Box>
        </VStack>
      </Box>
    </SectionLayout>
  );
};

export { Resume };
